// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Benefits-module--wrap--28TCf","inner":"Benefits-module--inner--Wmqnm","title":"Benefits-module--title--3y1qN","list":"Benefits-module--list--3EdEd"};